// TODO: ninesegsAnalyzer app からの依存をなくす
import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'
import { type TranslationSchema } from '~/locales/resources'

import { type FilterText } from './types'

export type ScreenLabel = `${string} - ${string}`

export type FigureInfoGroupFilter = {
  brands: {
    name: string
    segments: string[]
  }[]
  name: string
}

export type FigureInfoOverlapGroupFilter = {
  brand1: string
  brand2: string
  combinations: {
    brand1: string
    brand2: string
    combination: string
  }[]
  name: string
}

type RequiredFigureInfo = {
  brandAccountId: string
  pathKey: PathKey
}

type CommonFigureInfo = {
  creator?: string
  screenLabel?: ScreenLabel
}

type SpecificFigureInfo = {
  figureType?: string
  survey?: string
  brandGroup?: string
  columnCustomerAttributes?: string[]
  brand?: string
  surveyGroup?: string
  tableChartType?: string
  dataDisplayType?: string
  segmentDisplayType?: string
  segmentRoute?: string
  npiDriverQuestion?: string
  importanceQuestion?: string
  liftSaQuestion?: string
  isValueAxisMaxStandardized?: string
  groupFilters?: FigureInfoGroupFilter[]
  overlapBrand1?: string
  overlapBrand2?: string
  overlapGroupFilters?: FigureInfoOverlapGroupFilter[]
  resultViewerType?: string
  questions?: string[]
  customerAttributes?: string[]
  surveyFilter?: FilterText[][]
  surveyGroupFilter?: FilterText[][]
}

export type FigureInfo = CommonFigureInfo &
  RequiredFigureInfo &
  SpecificFigureInfo

export const figureInfoKeys = [
  'creator',
  'screenLabel',
  'figureType',
  'survey',
  'brandGroup',
  'columnCustomerAttributes',
  'brand',
  'surveyGroup',
  'tableChartType',
  'dataDisplayType',
  'segmentDisplayType',
  'segmentRoute',
  'npiDriverQuestion',
  'importanceQuestion',
  'liftSaQuestion',
  'isValueAxisMaxStandardized',
  'groupFilters',
  'overlapBrand1',
  'overlapBrand2',
  'overlapGroupFilters',
  'resultViewerType',
  'questions',
  'customerAttributes',
  'surveyFilter',
  'surveyGroupFilter',
] as const satisfies readonly (keyof (CommonFigureInfo & SpecificFigureInfo))[]

export type FigureInfoKey = (typeof figureInfoKeys)[number]

export const translatableFigureInfoKeys = [
  'dataDisplayType',
  'segmentDisplayType',
  'resultViewerType',
  'tableChartType',
  'screenLabel',
  'figureType',
] as const

export type TranslatableFigureInfoKey =
  (typeof translatableFigureInfoKeys)[number]

export const isTranslatableFigureInfoKey = (
  key: FigureInfoKey,
): key is TranslatableFigureInfoKey =>
  (translatableFigureInfoKeys as readonly string[]).includes(key)

export const figureInfoKeyLabelI18nKeyMap: Record<
  FigureInfoKey,
  keyof TranslationSchema
> = {
  brand: 'brand_type',
  brandGroup: 'brand_group',
  columnCustomerAttributes: 'customized_segments_column',
  creator: 'owner',
  customerAttributes: 'customized_segments',
  dataDisplayType: 'data_display_format',
  figureType: 'chart_type',
  groupFilters: 'select_group',
  importanceQuestion: 'importance_question',
  isValueAxisMaxStandardized: 'fix_yaxis',
  liftSaQuestion: 'lift_sa_question',
  npiDriverQuestion: 'npi_driver_question',
  overlapBrand1: 'compare_brand_1',
  overlapBrand2: 'compare_brand_2',
  overlapGroupFilters: 'select_group_overlap',
  questions: 'questionnaire',
  resultViewerType: 'tablegraph_format_result_viewer',
  screenLabel: 'analysis_function',
  segmentDisplayType: 'segment_format',
  segmentRoute: 'segment_route',
  survey: 'survey',
  surveyFilter: 'filter_survey',
  surveyGroup: 'survey_group',
  surveyGroupFilter: 'filter_survey_group',
  tableChartType: 'tablegraph_format_table_chart',
}

export type FigureMeta = {
  isArchivable: boolean
  isDeletable: boolean
  isUnarchivable: boolean
}
